import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const createOpco = SettingsService.createOpcoSettingsOpcoPost

export const updateOpco = SettingsService.updateOpcoSettingsOpcoOpcoIdPatch

export const getAllOpco = SettingsService.readOpcoSettingsOpcoGet

export const deleteOpco = SettingsService.deleteOpcoSettingsOpcoOpcoIdDelete

export const getOpcoById = SettingsService.readOpcoSettingsOpcoOpcoIdGet

export const downloadOpcoTemplateGet = SettingsService.downloadTemplateSettingsDownloadOpcoTemplateGet

export const uploadOpcoPost = SettingsService.uploadDataSettingsUploadOpcosPost

export const postConfigValRule = SettingsService.configFileToDbSettingsOpcosOpcoIdConfigValidationRulesPost